(() => {
  const header = document.querySelector('[data-header]');
  const toggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (header) {
    const setScrolled = () => header.classList.toggle('is-scrolled', window.scrollY > 20);
    setScrolled();
    window.addEventListener('scroll', setScrolled, { passive: true });
  }

  if (toggle && mobileMenu) {
    toggle.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      toggle.classList.toggle('is-open', open);
    });
  }

  const hero = document.querySelector('[data-hero]');
  if (hero) {
    const slides = [...hero.querySelectorAll('[data-hero-slide]')];
    const dots = hero.querySelector('[data-hero-dots]');
    let current = 0;
    let timer;

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === current));
      if (dots) {
        [...dots.children].forEach((dot, i) => dot.classList.toggle('is-active', i === current));
      }
    };

    if (dots) {
      slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Slide ${i + 1}`);
        dot.addEventListener('click', () => {
          show(i);
          restart();
        });
        dots.appendChild(dot);
      });
    }

    const next = () => show(current + 1);
    const restart = () => {
      window.clearInterval(timer);
      timer = window.setInterval(next, 5000);
    };

    hero.querySelector('[data-hero-prev]')?.addEventListener('click', () => {
      show(current - 1);
      restart();
    });
    hero.querySelector('[data-hero-next]')?.addEventListener('click', () => {
      show(current + 1);
      restart();
    });
    show(0);
    restart();
  }
})();

// Thumbnail controls leave the page position unchanged; native scrolling also works.
document.querySelectorAll('[data-gallery-index]').forEach(button => {
  button.addEventListener('click', () => {
    const track = document.getElementById(button.getAttribute('aria-controls'));
    const slide = track?.children[Number(button.dataset.galleryIndex)];
    if (slide) track.scrollTo({ left: slide.offsetLeft - track.firstElementChild.offsetLeft, behavior: 'instant' });
  });
});
